export default __webpack_public_path__ + "static/media/B4_21.e221804c.mp3";